import React from "react";
import { Helmet } from "react-helmet";
import "../css/privacy-policy.css";

const PrivacyPolicy = () => {
  return (
    <div>

      <Helmet>
        <title>Privacy Policy | Shreesha Tours & Travels</title>

        <meta
          name="description"
          content="Privacy Policy for Shreesha Tours & Travels. Learn how we collect, use, and protect your personal information for tour packages, travel services, holiday packages, and transportation solutions."
        />

        <meta
          name="keywords"
          content="Shreesha Tours & Travels, Tour Packages, Travel Services, Holiday Packages, Taxi Service, Privacy Policy"
        />
      </Helmet>

   
 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Privacy Policy
        </h2>
      </div>
    </section>

     



      <section className="privacy-policy">

        <div className="container px-0">

          <div className="row g-0">

            <img
              className="img-fluid"
              src="/images/privacy.avif"
              alt="Privacy Policy"
            />


            <div className="col-12 col-md-12">


              <h3 className="title">
                Privacy Policy – Shreesha Tours & Travels
              </h3>


              <p>
                At <b>Shreesha Tours & Travels</b>, we respect your privacy
                and are committed to protecting your personal information.
                This Privacy Policy explains how we collect, use, and
                protect your information when you use our tour packages,
                holiday trips, transportation services, and travel
                solutions.
              </p>



              <div className="section">


                <p className="highlight darkcolor">
                  Information We Collect:
                </p>


                <p className="highlight darkcolor">
                  1. Personal Information:
                </p>


                <p>
                  When you contact us or book our travel services, we may
                  collect information such as your name, phone number,
                  email address, travel requirements, pickup location,
                  destination details, and payment information.
                </p>



                <p className="highlight darkcolor">
                  2. Travel Booking Information:
                </p>


                <p>
                  We collect details related to your journey including
                  tour package selection, travel dates, number of
                  passengers, vehicle requirements, pickup and drop
                  locations, and other trip details.
                </p>



                <p className="highlight darkcolor">
                  3. Website Usage Information:
                </p>


                <p>
                  We may collect technical information such as IP address,
                  browser type, device information, and website usage data
                  to improve our website performance and customer
                  experience.
                </p>


              </div>





              <div className="section">


                <p className="highlight darkcolor">
                  How We Use Your Information:
                </p>



                <p className="highlight darkcolor">
                  1. Travel Service Management:
                </p>


                <p>
                  Your information helps us manage bookings, arrange
                  transportation, prepare travel plans, and provide
                  smooth and reliable travel services.
                </p>



                <p className="highlight darkcolor">
                  2. Customer Support:
                </p>


                <p>
                  We use your contact information to confirm bookings,
                  provide travel updates, answer queries, and offer
                  customer assistance.
                </p>



                <p className="highlight darkcolor">
                  3. Service Improvement:
                </p>


                <p>
                  Customer feedback and service information help us
                  improve our tours, packages, and overall travel
                  experience.
                </p>



                <p className="highlight darkcolor">
                  4. Offers & Updates:
                </p>


                <p>
                  With your permission, we may send information about new
                  tour packages, discounts, offers, and travel services
                  provided by Shreesha Tours & Travels.
                </p>


              </div>





              <div className="section">


                <p className="highlight darkcolor">
                  Information Sharing:
                </p>



                <p className="highlight darkcolor">
                  1. Service Partners:
                </p>


                <p>
                  Necessary information may be shared with drivers,
                  hotels, transport providers, and travel partners to
                  complete your travel arrangements.
                </p>



                <p className="highlight darkcolor">
                  2. Legal Requirements:
                </p>


                <p>
                  We may share information when required by law,
                  government authorities, or to protect customer safety
                  and legal rights.
                </p>


              </div>





              <div className="section">


                <p className="highlight darkcolor">
                  Data Security:
                </p>


                <p>
                  Shreesha Tours & Travels follows appropriate security
                  measures to protect customer information from
                  unauthorized access, misuse, or disclosure.
                </p>



                <p className="highlight darkcolor">
                  Your Rights:
                </p>


                <p>
                  Customers may request access, correction, or deletion
                  of their personal information and can choose whether to
                  receive promotional communications.
                </p>



                <p className="highlight darkcolor">
                  Policy Updates:
                </p>


                <p>
                  This Privacy Policy may be updated from time to time.
                  Any changes will be published on this page.
                </p>


              </div>


            </div>

          </div>





          <div className="contact-info">


            <h2>
              Contact Us
            </h2>



            <p>
              If you have any questions regarding this Privacy Policy,
              please contact Shreesha Tours & Travels:
            </p>



            <ul>


              <li>
                <b>Mobile:</b>{" "}
                <a href="tel:+918355835813">
                  +91 83558 35813
                </a>
                {" / "}
                <a href="tel:+919930929439">
                  +91 99309 29439
                </a>
                {" / "}
                <a href="tel:+919022432779">
                  +91 90224 32779
                </a>
              </li>




              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@shreeshatravels.com">
                  booking@shreeshatravels.com
                </a>
              </li>




              <li>

                <b className="darkcolorrr">
                  Address:
                </b>

                <br />


                <h6>
                  Shreesha Tours & Travels
                </h6>


                Office 125, Saishraddha CHS,<br />
                Plot No 47, Near Koparkhairane Police Station,<br />
                Sector 5, Sector 4, Ghansoli,<br />
                Navi Mumbai, Maharashtra, India - 400701.


              </li>


            </ul>


          </div>



        </div>

      </section>


    </div>
  );
};


export default PrivacyPolicy;